/**
 * Shared type scale for the Vidu R1 landing page.
 *
 * Every block pulls its heading and paragraph sizes from here so the page reads
 * as one document instead of a stack of independently-tuned sections. Each
 * constant carries size + line-height only — weight, colour and spacing stay at
 * the call site, since those legitimately differ per block.
 *
 * Two tiers exist by necessity:
 *  - In-flow text (`SUBHEAD` / `BODY`) sits in the normal page column.
 *  - Overlay text (`OVERLAY_*`) is layered on media tiles, some as narrow as
 *    190px, where the in-flow sizes would not fit.
 */

/** Section titles. Fluid between the mobile and desktop ends of the scale. */
export const SECTION_TITLE = 'text-[clamp(26px,3.2vw,44px)] leading-[1.1]';

/**
 * Full class for a centred section heading — size, weight, tracking and the
 * gap down to its content. Every top-level section reuses this so the titles
 * are identical in size and sit the same distance above their block.
 */
export const SECTION_HEADING = `mb-12 text-balance text-center font-semibold tracking-[-1.5px] sm:mb-8 sm:tracking-[-0.5px] ${SECTION_TITLE}`;

/** Sub-headings inside a section: feature cards, steps, FAQ questions. */
export const SUBHEAD = 'text-[20px] leading-[1.4] sm:text-[17px]';

/** Body copy: every description, subtitle and answer paragraph. */
export const BODY = 'text-[15px] leading-[1.6] sm:text-[14px]';

/** Caption title layered over a media tile. */
export const OVERLAY_TITLE = 'text-[14px] leading-tight';

/** Caption body layered over a media tile. */
export const OVERLAY_BODY = 'text-[13px] leading-[1.45]';

/** Small uppercase label (index numbers, category tags). */
export const OVERLAY_EYEBROW = 'text-[10px] uppercase tracking-[0.13em]';
